<a
  (click)="clicked()"
  [title]="title()"
  [attr.aria-disabled]="disabled() || null"
  [class]="disabled() ? 'font-medium text-fg-disabled cursor-not-allowed' : 'font-medium text-brand hover:underline cursor-pointer'"
>
  <ng-content></ng-content>
</a>
